<template>
  <div class="test-view">
    <h1>Test View</h1>
    <p>This is a test view to verify routing works</p>
    <div class="debug-info">
      <h2>Debug Information:</h2>
      <ul>
        <li>Route Name: {{ $route.name }}</li>
        <li>Route Path: {{ $route.path }}</li>
        <li>Component Name: {{ $options.name }}</li>
      </ul>
    </div>
    <router-link to="/">Go to Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'TestView',
  mounted() {
    console.log('[TestView] Component mounted');
  }
}
</script>

<style scoped>
.test-view {
  padding: 100px 20px;
  min-height: 100vh;
  background-color: #f0f0f0;
}

.debug-info {
  margin-top: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>